import { __awaiter } from "tslib";
import { ref } from 'vue';
import ApiManager from '@/managers/apimanagers';
export const ONE_TIME_PASSCODE_CHANNEL_EMAIL = 'email';
export const ONE_TIME_PASSCODE_CHANNEL_SMS = 'sms';
/**
 * @summary ワンタイムパスコードの認証
 */
export const useOneTimePasscode = () => {
    const oneTimePasscodeId = ref();
    const isLoading = ref(false);
    /**
     * @returns API申請データの取得
     */
    const checkVerified = () => __awaiter(void 0, void 0, void 0, function* () {
        let result = false;
        try {
            isLoading.value = true;
            yield ApiManager.get(`/one-time-passcodes/verified`);
            result = true;
        }
        finally {
            isLoading.value = false;
        }
        return result;
    });
    const postOnetimePassword = (channel) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoading.value = true;
            const res = yield ApiManager.post(`one-time-passcodes/${channel}`, {});
            oneTimePasscodeId.value = res.id;
        }
        finally {
            isLoading.value = false;
        }
    });
    const resetOnetimePassword = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoading.value = true;
            yield ApiManager.post(`one-time-passcode/${oneTimePasscodeId.value}/resent`, {});
        }
        finally {
            isLoading.value = false;
        }
    });
    const verifyOnetimePassword = (passcode) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoading.value = true;
            yield ApiManager.post(`one-time-passcode/${oneTimePasscodeId.value}/verify`, { passcode });
        }
        finally {
            isLoading.value = false;
        }
    });
    return {
        oneTimePasscodeId,
        isLoading,
        checkVerified,
        postOnetimePassword,
        resetOnetimePassword,
        verifyOnetimePassword,
    };
};
